module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron jumbotron-parapple"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("Hello, welcome to Parapple!")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Online platform for parallel programming tutorials")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "thumbnail thumbnail-parapple"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/parallel.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('h3', [_vm._v("Parallel Programming?")]), _vm._v(" "), _vm._m(0), _vm._m(1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/docs"
    }
  }, [_vm._v("Read more...")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "thumbnail thumbnail-parapple"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/parascript.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('h3', [_vm._v("Coding in Parascript")]), _vm._v(" "), _c('p', [_vm._v("The tutorials are solved by programming the agents in Parascript—a simplified clone of JavaScript. The syntax should feel very familiar if you know the basics of any C-like language.")]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/docs"
    }
  }, [_vm._v("Documentation")])], 1)])])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Running more programs in parallel (think multiple servers/CPUs/threads...) is cool, but it can get "), _c('a', {
    attrs: {
      "target": "_balnk",
      "href": "http://www.thinkingparallel.com/2007/08/06/what-makes-parallel-programming-hard/"
    }
  }, [_vm._v("hard")]), _vm._v(".\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("On this platform, you can try parallel programming exercies by writing code for multiple "), _c('em', [_vm._v("agents")]), _vm._v(" and run the simulation right in your browser.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('div', {
    staticClass: "thumbnail thumbnail-parapple"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/ladybugs.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('h3', [_vm._v("Extensions & Visualizations")]), _vm._v(" "), _c('p', [_vm._v("Packages written in JavaScript can add arbitrary functionality to the Parascript programming language. They can also provide visualizations for the tutorials. Most tutorials you'll find here use the sample "), _c('em', [_vm._v("Ladybugs package")]), _vm._v(" which runs on top of "), _c('a', {
    attrs: {
      "href": "http://www.pixijs.com/"
    }
  }, [_vm._v("PixiJS")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "static/devDocs.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Developing packages and tutorials")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("Parapple is developed as a master thesis project by "), _c('a', {
    attrs: {
      "href": "mailto:emanuel.buzek@roke.cz"
    }
  }, [_vm._v("Emanuel Buzek")]), _vm._v(" at "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.mff.cuni.cz/to.en/"
    }
  }, [_vm._v("MFF UK")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("Icons made by "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.freepik.com",
      "title": "Freepik"
    }
  }, [_vm._v("Freepik")]), _vm._v(" from "), _c('a', {
    attrs: {
      "href": "http://www.flaticon.com",
      "title": "Flaticon"
    }
  }, [_vm._v("www.flaticon.com")]), _vm._v(" licensed by "), _c('a', {
    attrs: {
      "href": "http://creativecommons.org/licenses/by/3.0/",
      "title": "Creative Commons BY 3.0",
      "target": "_blank"
    }
  }, [_vm._v("CC 3.0 BY")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-295a81dc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workbench/Welcome.vue
// module id = 1535
// module chunks = 2